__turbopack_context__.v({
  "arrangerAgent": "datarooms-module-scss-module__QHAjEW__arrangerAgent",
  "card": "datarooms-module-scss-module__QHAjEW__card",
  "cardInnerHorizontal": "datarooms-module-scss-module__QHAjEW__cardInnerHorizontal",
  "colAlerts": "datarooms-module-scss-module__QHAjEW__colAlerts",
  "colArrangerAgent": "datarooms-module-scss-module__QHAjEW__colArrangerAgent",
  "colDeclaration": "datarooms-module-scss-module__QHAjEW__colDeclaration",
  "colExpDate": "datarooms-module-scss-module__QHAjEW__colExpDate",
  "colFiles": "datarooms-module-scss-module__QHAjEW__colFiles",
  "colLastDate": "datarooms-module-scss-module__QHAjEW__colLastDate",
  "colName": "datarooms-module-scss-module__QHAjEW__colName",
  "colPermissions": "datarooms-module-scss-module__QHAjEW__colPermissions",
  "colSector": "datarooms-module-scss-module__QHAjEW__colSector",
  "colSize": "datarooms-module-scss-module__QHAjEW__colSize",
  "colSponsor": "datarooms-module-scss-module__QHAjEW__colSponsor",
  "colStatus": "datarooms-module-scss-module__QHAjEW__colStatus",
  "colTransactionType": "datarooms-module-scss-module__QHAjEW__colTransactionType",
  "colUsers": "datarooms-module-scss-module__QHAjEW__colUsers",
  "columnDisable": "datarooms-module-scss-module__QHAjEW__columnDisable",
  "copyIcon": "datarooms-module-scss-module__QHAjEW__copyIcon",
  "countLabel": "datarooms-module-scss-module__QHAjEW__countLabel",
  "cropTextBankName": "datarooms-module-scss-module__QHAjEW__cropTextBankName",
  "cropTextCol": "datarooms-module-scss-module__QHAjEW__cropTextCol",
  "dataRoomListPaginator": "datarooms-module-scss-module__QHAjEW__dataRoomListPaginator",
  "dataTableContainer": "datarooms-module-scss-module__QHAjEW__dataTableContainer",
  "dataroomActions": "datarooms-module-scss-module__QHAjEW__dataroomActions",
  "dataroomExpDate": "datarooms-module-scss-module__QHAjEW__dataroomExpDate",
  "dataroomExpDateWrp": "datarooms-module-scss-module__QHAjEW__dataroomExpDateWrp",
  "dataroomTable": "datarooms-module-scss-module__QHAjEW__dataroomTable",
  "deactivatedDataroom": "datarooms-module-scss-module__QHAjEW__deactivatedDataroom",
  "declarationCell": "datarooms-module-scss-module__QHAjEW__declarationCell",
  "declarationCellDisabled": "datarooms-module-scss-module__QHAjEW__declarationCellDisabled",
  "denied": "datarooms-module-scss-module__QHAjEW__denied",
  "disabled": "datarooms-module-scss-module__QHAjEW__disabled",
  "errorMessage": "datarooms-module-scss-module__QHAjEW__errorMessage",
  "exploreSetsActions": "datarooms-module-scss-module__QHAjEW__exploreSetsActions",
  "follow": "datarooms-module-scss-module__QHAjEW__follow",
  "hideDeactivated": "datarooms-module-scss-module__QHAjEW__hideDeactivated",
  "hideTooltipOnMobile": "datarooms-module-scss-module__QHAjEW__hideTooltipOnMobile",
  "iconWarning": "datarooms-module-scss-module__QHAjEW__iconWarning",
  "iconWrapper": "datarooms-module-scss-module__QHAjEW__iconWrapper",
  "initialPreloaderWrp": "datarooms-module-scss-module__QHAjEW__initialPreloaderWrp",
  "isActionItemVisible": "datarooms-module-scss-module__QHAjEW__isActionItemVisible",
  "isEmpty": "datarooms-module-scss-module__QHAjEW__isEmpty",
  "isExpired": "datarooms-module-scss-module__QHAjEW__isExpired",
  "isPublished": "datarooms-module-scss-module__QHAjEW__isPublished",
  "isTabActive": "datarooms-module-scss-module__QHAjEW__isTabActive",
  "link": "datarooms-module-scss-module__QHAjEW__link",
  "mobileColName": "datarooms-module-scss-module__QHAjEW__mobileColName",
  "mobileColValue": "datarooms-module-scss-module__QHAjEW__mobileColValue",
  "mobileDataroomActions": "datarooms-module-scss-module__QHAjEW__mobileDataroomActions",
  "mobilePaginator": "datarooms-module-scss-module__QHAjEW__mobilePaginator",
  "pending": "datarooms-module-scss-module__QHAjEW__pending",
  "requestStatus": "datarooms-module-scss-module__QHAjEW__requestStatus",
  "searchBlock": "datarooms-module-scss-module__QHAjEW__searchBlock",
  "searchInput": "datarooms-module-scss-module__QHAjEW__searchInput",
  "searchInputDisabled": "datarooms-module-scss-module__QHAjEW__searchInputDisabled",
  "searchInputFixedWidth": "datarooms-module-scss-module__QHAjEW__searchInputFixedWidth",
  "searchInputFormField": "datarooms-module-scss-module__QHAjEW__searchInputFormField",
  "sector": "datarooms-module-scss-module__QHAjEW__sector",
  "spanLink": "datarooms-module-scss-module__QHAjEW__spanLink",
  "statusIndicator": "datarooms-module-scss-module__QHAjEW__statusIndicator",
  "tabs": "datarooms-module-scss-module__QHAjEW__tabs",
  "tabsLine": "datarooms-module-scss-module__QHAjEW__tabsLine",
  "tooltip": "datarooms-module-scss-module__QHAjEW__tooltip",
  "tooltipWarningWrapper": "datarooms-module-scss-module__QHAjEW__tooltipWarningWrapper",
  "transactionType": "datarooms-module-scss-module__QHAjEW__transactionType",
  "underwritersWrapper": "datarooms-module-scss-module__QHAjEW__underwritersWrapper",
  "usersCount": "datarooms-module-scss-module__QHAjEW__usersCount",
  "wrpCountLabel": "datarooms-module-scss-module__QHAjEW__wrpCountLabel",
});
